import { Box, Typography } from "@mui/material";
import React from "react";
import { ArrowRigntLine } from "./svg-icons";

export const IconText = ({
  text,
  image,
  onClick,
}: {
  text: string;
  image: any;
  onClick: () => void;
}) => {
  return (
    <Box onClick={onClick} sx={{cursor:'pointer'}}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          py: 1,
          borderBottom: "1px solid #CED7DE",
          my: 1,
        }}
      >
        <Box style={{ display: "flex", flexDirection: "row", gap: 10 }}>
          <img src={image} alt="" style={{ width: 26, height: 25 }} />
          <Typography
            variant="body1"
            sx={{
              color:
                text === "Delete my account and data" ? "#EB5757" : "#4A5E6D",
            }}
          >
            {text}
          </Typography>
        </Box>
        <ArrowRigntLine />
      </Box>
    </Box>
  );
};
